import { render, staticRenderFns } from "./MgnlDynamicWrapper.vue?vue&type=template&id=18c190de&"
import script from "./MgnlDynamicWrapper.vue?vue&type=script&lang=js&"
export * from "./MgnlDynamicWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports